<template>
  <router-link
    :class="{
      'navigation-list__item': true,
      'navigation-list__item_active': active,
      'navigation-list__item_collapsed': collapsed
    }"
    :to="link"
  >
    <modulesIcon v-if="title==='Модули'"/>
    <newsIcon v-if="title==='Новости'"/>
    <productIcon v-if="title==='Товары'"/>
    <projectIcon v-if="title==='Проекты'"/>
    <UserSetting v-if="title==='Безопастность'"/>
    <span>{{ title }}</span>
  </router-link>
</template>

<script>
// import { ref } from 'vue'
import modulesIcon from '@/components/icons/modulesIcon.vue'
import newsIcon from '@/components/icons/newsIcon.vue'
import productIcon from '@/components/icons/productIcon.vue'
import projectIcon from '@/components/icons/projectIcon.vue'
import UserSetting from '@/components/icons/UserSetting.vue'

export default {
  name: 'NavigationBtn',
  components: {
    modulesIcon,
    newsIcon,
    productIcon,
    projectIcon,
    UserSetting
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: '/'
    }
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.navigation-list {
  &__item {
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 10px 12px;
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    background-color: #FFFFFF;
    border: 1px solid #C8C8C8;
    border-radius: 6px;
    transition: 0.5s;
    text-decoration: none;
    cursor: pointer;
    overflow: hidden;

    @media(any-hover: hover) {
      &:hover {
        color: #000000;
        background-color: #E6E6E6;
        transition: 0.5s;

        :deep(svg) {
          path {
            fill: #000000;
          }
        }
      }
    }

    &:active {
      background-color: #0080B0;
      color: #FFFFFF;
      transition: 0.5s;
      :deep(svg) {
        path {
          fill: #FFFFFF;
        }
      }
    }

    &_active {
      background-color: #00ABEC;
      color: #FFFFFF;
      transition: 0.5s;
      border-color: transparent;

      :deep(svg) {
        path {
          fill: #FFFFFF;
        }
      }
    }

    &_collapsed {
      span {
        display: none;
      }
      padding: 10px;
    }
  }
}
</style>
